import { render } from "./attendance-model.vue?vue&type=template&id=16b3a3ed"
import script from "./attendance-model.vue?vue&type=script&lang=js"
export * from "./attendance-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__